import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const GarlandFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 83.332031 0 L 916.667969 0 C 962.691406 0 1000 37.300781 1000 83.3125 L 1000 1249.6875 C 1000 1295.699219 962.691406 1333 916.667969 1333 L 83.332031 1333 C 37.308594 1333 0 1295.699219 0 1249.6875 L 0 83.3125 C 0 37.300781 37.308594 0 83.332031 0 Z M 83.332031 0 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 822.285156 -43.273438 C 822.285156 -40.566406 822.285156 -37.863281 822.285156 -35.15625 C 692.558594 26.445312 555.066406 49.050781 409.808594 32.667969 C 327.378906 23.191406 249.589844 0.582031 176.453125 -35.15625 C 176.453125 -37.863281 176.453125 -40.566406 176.453125 -43.273438 C 179.101562 -45.136719 182.046875 -45.71875 185.28125 -45.011719 C 362.382812 35.5 544.445312 46.320312 731.464844 -12.550781 C 759.003906 -22.019531 785.910156 -32.839844 812.195312 -45.011719 C 815.976562 -46.042969 819.339844 -45.464844 822.285156 -43.273438 Z M 822.285156 -43.273438 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 803.363281 -14.289062 C 804.050781 -14.21875 804.46875 -13.832031 804.625 -13.128906 C 791.679688 15.035156 778.855469 43.246094 766.152344 71.503906 C 746.601562 89.476562 727.050781 107.445312 707.5 125.417969 C 706.660156 126.1875 705.816406 126.1875 704.976562 125.417969 C 699.089844 112.664062 693.203125 99.910156 687.316406 87.15625 C 722.214844 55.082031 757.113281 23.003906 792.011719 -9.070312 C 795.914062 -10.863281 799.695312 -12.601562 803.363281 -14.289062 Z M 803.363281 -14.289062 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 218.078125 -3.855469 C 232.769531 1.347656 247.484375 6.566406 262.226562 11.796875 C 248.980469 23.972656 235.738281 36.144531 222.492188 48.316406 C 216.882812 35.160156 210.785156 22.214844 204.203125 9.480469 C 209.085938 5.1875 213.710938 0.742188 218.078125 -3.855469 Z M 218.078125 -3.855469 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 756.695312 4.261719 C 758.621094 4.28125 759.253906 5.054688 758.585938 6.582031 C 732.957031 29.171875 707.515625 51.972656 682.269531 74.984375 C 678.886719 70.332031 676.992188 65.308594 676.59375 59.910156 C 692.78125 45.035156 708.972656 30.152344 725.160156 15.277344 C 736.140625 12.367188 746.652344 8.695312 756.695312 4.261719 Z M 756.695312 4.261719 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 273.582031 15.855469 C 279.976562 17.234375 286.285156 18.972656 292.5 21.074219 C 272.949219 39.042969 253.398438 57.011719 233.847656 74.984375 C 230.835938 69.40625 229.152344 63.609375 228.800781 57.59375 C 243.980469 43.832031 258.910156 29.921875 273.582031 15.855469 Z M 273.582031 15.855469 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 697.410156 22.8125 C 698.699219 23.273438 698.910156 24.042969 698.039062 25.128906 C 689.191406 33.457031 680.152344 41.570312 670.917969 49.476562 C 667.644531 43.53125 665.121094 37.351562 663.351562 30.925781 C 675.160156 29.359375 686.511719 26.65625 697.410156 22.8125 Z M 697.410156 22.8125 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 303.851562 25.128906 C 314.402344 26.816406 324.914062 28.746094 335.386719 30.925781 C 330.589844 44.347656 324.914062 57.488281 318.359375 70.347656 C 298.582031 88.71875 278.609375 106.882812 258.441406 124.835938 C 251.507812 112.078125 245.203125 98.941406 239.523438 85.417969 C 260.992188 65.296875 282.4375 45.203125 303.851562 25.128906 Z M 303.851562 25.128906 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 426.207031 46 C 450.558594 47.617188 474.945312 48.390625 499.371094 48.316406 C 523.792969 48.195312 548.179688 47.617188 572.53125 46.578125 C 601.171875 72.304688 607.058594 101.867188 590.191406 135.269531 C 588.929688 136.816406 587.667969 136.816406 586.40625 135.269531 C 579.0625 128.714844 571.914062 121.953125 564.960938 114.980469 C 563.410156 114.078125 561.730469 113.496094 559.917969 113.242188 C 549.480469 121.285156 539.390625 129.785156 529.644531 138.75 C 521.425781 130.621094 513.019531 122.695312 504.414062 114.980469 C 502.863281 114.078125 501.183594 113.496094 499.371094 113.242188 C 488.933594 121.285156 478.84375 129.785156 469.097656 138.75 C 460.878906 130.621094 452.472656 122.695312 443.867188 114.980469 C 442.316406 114.078125 440.636719 113.496094 438.824219 113.242188 C 429.195312 120.738281 419.734375 128.464844 410.441406 136.429688 C 404.886719 130.023438 401.523438 122.675781 400.351562 114.402344 C 395.796875 87.339844 404.417969 64.539062 426.207031 46 Z M 544.777344 64.550781 C 547.851562 64.335938 550.585938 65.109375 552.976562 66.867188 C 556.625 73.832031 559.777344 80.980469 562.4375 88.316406 C 561.820312 90.613281 560.558594 92.546875 558.65625 94.113281 C 547.300781 94.886719 535.949219 94.886719 524.597656 94.113281 C 521.078125 91.550781 520.027344 88.265625 521.445312 84.257812 C 528.957031 77.265625 536.734375 70.695312 544.777344 64.550781 Z M 446.390625 65.707031 C 449.949219 65.417969 453.308594 65.996094 456.480469 67.449219 C 463.800781 73.011719 470.738281 79.003906 477.292969 85.417969 C 478.28125 88.613281 477.652344 91.511719 475.402344 94.113281 C 464.601562 95.976562 453.667969 96.363281 442.605469 95.273438 C 436.078125 92.355469 434.605469 87.910156 438.191406 81.941406 C 440.574219 76.308594 443.308594 70.898438 446.390625 65.707031 Z M 446.390625 65.707031 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 302.589844 99.332031 C 303.523438 99.179688 304.367188 99.371094 305.113281 99.910156 C 297.585938 116.410156 289.808594 132.835938 281.777344 149.183594 C 277.515625 151.992188 273.101562 152.1875 268.535156 149.761719 C 266.433594 145.511719 264.332031 141.261719 262.226562 137.011719 C 275.9375 124.601562 289.390625 112.042969 302.589844 99.332031 Z M 302.589844 99.332031 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 749.125 101.648438 C 750.230469 101.496094 751.070312 101.882812 751.648438 102.808594 C 744.585938 117.832031 737.648438 132.90625 730.835938 148.023438 C 727.605469 151.328125 723.613281 152.292969 718.851562 150.921875 C 714.25 146.917969 711.941406 142.089844 711.914062 136.429688 C 724.574219 124.988281 736.976562 113.394531 749.125 101.648438 Z M 749.125 101.648438 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 437.5625 127.15625 C 448.058594 135.640625 458.570312 144.144531 469.097656 152.660156 C 479.53125 144.621094 489.621094 136.121094 499.371094 127.15625 C 509.058594 135.871094 518.941406 144.371094 529.011719 152.660156 C 530.359375 151.859375 531.832031 151.28125 533.425781 150.921875 C 542.066406 142.789062 550.894531 134.867188 559.917969 127.15625 C 567.789062 133.035156 574.515625 139.796875 580.097656 147.445312 C 570.460938 158.84375 557.847656 166.1875 542.257812 169.472656 C 515.398438 171.339844 488.492188 171.726562 461.527344 170.632812 C 444.285156 167.445312 429.777344 159.90625 418.007812 148.023438 C 417.167969 147.25 417.167969 146.480469 418.007812 145.707031 C 424.785156 139.675781 431.300781 133.492188 437.5625 127.15625 Z M 437.5625 127.15625 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 822.285156 180.488281 C 822.285156 183.191406 822.285156 185.898438 822.285156 188.601562 C 721.566406 237.203125 614.136719 261.550781 500 261.644531 C 385.902344 261.078125 278.054688 237.117188 176.453125 189.761719 C 176.453125 186.285156 176.453125 182.804688 176.453125 179.328125 C 179.699219 178.105469 183.0625 177.910156 186.542969 178.746094 C 366.628906 260.066406 551.210938 269.726562 740.296875 207.734375 C 764.4375 199.34375 787.984375 189.683594 810.933594 178.746094 C 815.125 177.667969 818.910156 178.246094 822.285156 180.488281 Z M 822.285156 180.488281 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 778.136719 219.90625 C 779.820312 219.90625 781.5 219.90625 783.183594 219.90625 C 793.8125 260.335938 804.742188 300.71875 815.980469 341.0625 C 815.558594 341.640625 815.136719 342.21875 814.71875 342.800781 C 802.847656 339.164062 791.074219 335.296875 779.398438 331.207031 C 780.820312 308.535156 769.46875 294.425781 745.339844 288.890625 C 726.839844 287.828125 713.59375 294.976562 705.605469 310.335938 C 700.128906 324.585938 702.859375 337.335938 713.804688 348.597656 C 706.703125 356.671875 699.136719 364.402344 691.101562 371.785156 C 684.464844 352.804688 679 333.480469 674.703125 313.816406 C 702.527344 308.289062 714.933594 292.445312 711.914062 266.28125 C 709.871094 258.660156 705.878906 252.089844 699.929688 246.570312 C 715.414062 241.632812 730.972656 236.804688 746.601562 232.078125 C 757.496094 228.558594 768.007812 224.5 778.136719 219.90625 Z M 778.136719 219.90625 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 214.292969 224.542969 C 236.929688 224.679688 246.8125 235.113281 243.9375 255.847656 C 236.363281 271.824219 223.539062 277.042969 205.464844 271.496094 C 204.109375 270.640625 203.269531 269.480469 202.941406 268.019531 C 207.226562 253.617188 211.011719 239.125 214.292969 224.542969 Z M 214.292969 224.542969 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 252.136719 232.660156 C 281.113281 242.40625 310.546875 250.714844 340.433594 257.585938 C 333.570312 281.46875 326.425781 305.234375 318.988281 328.886719 C 307.066406 325.6875 295.714844 327.039062 284.933594 332.945312 C 281.765625 335.089844 278.613281 337.210938 275.472656 339.320312 C 268.390625 333.003906 261.453125 326.433594 254.660156 319.613281 C 245.527344 322.796875 236.277344 325.503906 226.910156 327.726562 C 224.5625 309.90625 214.050781 298.121094 195.375 292.367188 C 196.558594 288.574219 198.03125 284.902344 199.789062 281.351562 C 223.203125 289.144531 240.863281 282.960938 252.765625 262.804688 C 256.894531 252.691406 256.683594 242.644531 252.136719 232.660156 Z M 252.136719 232.660156 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 679.75 251.210938 C 689.941406 252.644531 696.457031 258.054688 699.300781 267.441406 C 703.011719 288.949219 693.132812 300.929688 669.65625 303.382812 C 666.335938 287.890625 662.132812 272.625 657.042969 257.585938 C 664.683594 255.449219 672.25 253.320312 679.75 251.210938 Z M 679.75 251.210938 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 423.683594 269.757812 C 472.671875 274.296875 521.65625 274.296875 570.636719 269.757812 C 572.53125 269.953125 574.421875 270.144531 576.316406 270.339844 C 595.925781 288.949219 601.601562 310.785156 593.34375 335.84375 C 586.480469 351.039062 574.917969 362.054688 558.65625 368.886719 C 557.183594 370.238281 555.710938 371.589844 554.238281 372.941406 C 553.820312 385.699219 553.398438 398.449219 552.976562 411.203125 C 548.679688 422.164062 540.480469 425.835938 528.382812 422.21875 C 526.4375 420.386719 524.964844 418.261719 523.964844 415.839844 C 523.546875 399.996094 523.125 384.152344 522.707031 368.304688 C 519.339844 365.214844 515.976562 365.214844 512.613281 368.304688 C 512.195312 383.378906 511.773438 398.449219 511.351562 413.523438 C 509.382812 422.25 503.707031 425.152344 494.324219 422.21875 C 492.851562 420.863281 491.382812 419.511719 489.910156 418.160156 C 489.488281 402.703125 489.066406 387.242188 488.648438 371.785156 C 486.636719 365.695312 482.851562 364.535156 477.292969 368.304688 C 476.875 384.152344 476.453125 399.996094 476.035156 415.839844 C 472.542969 422.417969 466.867188 424.542969 459.003906 422.21875 C 451.660156 419.71875 447.664062 414.886719 447.023438 407.726562 C 446.601562 395.746094 446.179688 383.765625 445.761719 371.785156 C 411.058594 356.304688 397.605469 331.183594 405.394531 296.425781 C 408.96875 285.976562 415.066406 277.085938 423.683594 269.757812 Z M 457.742188 297.582031 C 471.339844 297.902344 479.328125 304.277344 481.710938 316.714844 C 477.242188 332.484375 466.730469 337.511719 450.175781 331.785156 C 440.824219 324.488281 438.929688 315.792969 444.5 305.699219 C 448.28125 301.945312 452.695312 299.242188 457.742188 297.582031 Z M 534.6875 297.582031 C 546.519531 297.460938 554.296875 302.484375 558.023438 312.65625 C 557.269531 331.851562 546.96875 338.230469 527.121094 331.785156 C 517.34375 323.859375 515.871094 314.777344 522.707031 304.539062 C 526.292969 301.453125 530.285156 299.132812 534.6875 297.582031 Z M 534.6875 297.582031 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 732.726562 299.902344 C 754.675781 297.675781 766.027344 306.566406 766.785156 326.566406 C 758.980469 324.949219 751.414062 322.632812 744.078125 319.613281 C 737.617188 326.132812 730.886719 332.511719 723.898438 338.742188 C 723.054688 339.515625 722.214844 339.515625 721.375 338.742188 C 710.371094 322.125 714.15625 309.179688 732.726562 299.902344 Z M 732.726562 299.902344 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 192.851562 304.539062 C 208.691406 308.089844 216.046875 317.363281 214.925781 332.367188 C 204.789062 336.179688 194.488281 339.65625 184.019531 342.800781 C 185.515625 329.933594 188.460938 317.179688 192.851562 304.539062 Z M 192.851562 304.539062 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 301.332031 338.164062 C 305.976562 337.96875 310.597656 338.164062 315.207031 338.742188 C 316.375 339.191406 317.21875 339.964844 317.730469 341.0625 C 314.839844 351.507812 311.476562 361.75 307.636719 371.785156 C 299.914062 363.949219 292.347656 356.027344 284.933594 348.015625 C 289.171875 342.980469 294.636719 339.695312 301.332031 338.164062 Z M 301.332031 338.164062 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 208.332031 416.5625 L 791.667969 416.5625 C 803.171875 416.5625 812.5 425.886719 812.5 437.390625 L 812.5 1020.578125 C 812.5 1032.082031 803.171875 1041.40625 791.667969 1041.40625 L 208.332031 1041.40625 C 196.828125 1041.40625 187.5 1032.082031 187.5 1020.578125 L 187.5 437.390625 C 187.5 425.886719 196.828125 416.5625 208.332031 416.5625 Z M 208.332031 416.5625 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="1150.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
